import React from 'react';
import {
    CheckboxGroupInput,
} from 'react-admin';
import MedicalProgramGroupByIdForm from "../helper/MedicalProgramGroupByIdForm";

const ProvisionCheckboxGroupInput = props => {
    const [choices, setChoices] = React.useState([]);
    const [current, setCurrent] = React.useState(null);

    const getSuggestions = async () => {
        let response = await fetch(
            process.env.REACT_APP_API_ENTRYPOINT + "/contracts?contract_number=" + props.contractNumber,
            {headers: {
                    'Accept': 'application/json',
                    'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                    'x-session': localStorage.getItem('session')
                }}
        );

        return await response.json();
    }

    React.useEffect(() => {
        if (current !== props.contractNumber) {
            getSuggestions().then(data => {
                //setChoices(MedicalProgramGroupByIdForm[data[0].idForm]);
                setChoices([
                    { id: 'GENERAL', name: 'Договір з реімбурсації' }
                ])
            });

            setCurrent(props.contractNumber);
        }
    });

    return (
        <CheckboxGroupInput
            source={props.source}
            label={props.label}
            validate={props.validate}
            choices={choices}
            {...props}
        />
    );
}

export default ProvisionCheckboxGroupInput;
